/* eslint-disable jsx-a11y/anchor-is-valid */
import {
    Box,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,

} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import SearchBar from "../../components/SearchBar";
import ViewAIHub from "../../Modals/aiHub";
import ShowChartOutlinedIcon from "@mui/icons-material/ShowChartOutlined";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";


const CostAnalytics = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    };
    const orderData = [
        {
            period: "11/1/2024",
            type: "Monthly",
            usage: "167,890",
            tokens: "68900.0K",
            credits: "49,200",
            cost: "$1678.90",
            overage: "1,890",
        },
        {
            period: "11/1/2024",
            type: "Monthly",
            usage: "98,770",
            tokens: "40890.0K",
            credits: "28,900",
            cost: "$987.70",
            overage: "440",
        },
        {
            period: "11/1/2024",
            type: "Monthly",
            usage: "56,780",
            tokens: "23450.0K",
            credits: "16,700",
            cost: "$567.80",
            overage: "560",
        },
        {
            period: "11/1/2024",
            type: "Monthly",
            usage: "12,340",
            tokens: "4560.0K",
            credits: "3,600",
            cost: "$123.40",
            overage: "890",
        },
        {
            period: "10/1/2024",
            type: "Monthly",
            usage: "156,780",
            tokens: "62340.0K",
            credits: "45,800",
            cost: "$1567.34",
            overage: "2,340",
        },
        {
            period: "9/1/2024",
            type: "Monthly",
            usage: "138,760",
            tokens: "54230.0K",
            credits: "40,500",
            cost: "$1423.89",
            overage: "720",
        },
        {
            period: "8/1/2024",
            type: "Monthly",
            usage: "142,890",
            tokens: "56780.0K",
            credits: "42,100",
            cost: "$1478.23",
            overage: "1,560",
        },
        {
            period: "7/1/2024",
            type: "Monthly",
            usage: "134,560",
            tokens: "52340.0K",
            credits: "38,900",
            cost: "$1389.45",
            overage: "890",
        },
        {
            period: "6/1/2024",
            type: "Monthly",
            usage: "125,430",
            tokens: "45670.0K",
            credits: "35,420",
            cost: "$1245.67",
            overage: "1,230",
        },
    ];


    return (
        <>
            <div className="main_title">
                <h1>Cost Analytics</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Cost Analytics
                </p>
            </div>
            <div className="stats_boxes gap_m">

                {/* Total Tokens */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            0.00M
                            <p>Total Tokens</p>
                        </h2>
                        <figure className="blue">
                            <ShowChartOutlinedIcon fontSize="large" />
                        </figure>
                    </div>

                    <div className="ai_insight positive">
                        <span>+18% from last month</span>
                    </div>
                </a>

                {/* Total Cost */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            $0.00
                            <p>Total Cost</p>
                        </h2>
                        <figure className="green">
                            <AttachMoneyOutlinedIcon fontSize="large" />
                        </figure>
                    </div>

                    <div className="ai_insight positive">
                        <span>+12% from last month</span>
                    </div>
                </a>

                {/* Avg Cost / Vendor */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            $0.00
                            <p>Avg Cost / Vendor</p>
                        </h2>
                        <figure className="purple">
                            <TrendingUpOutlinedIcon fontSize="large" />
                        </figure>
                    </div>

                    <div className="ai_insight neutral">
                        <span>Within budget</span>
                    </div>
                </a>

                {/* Overages */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            10,520
                            <p>Overages</p>
                        </h2>
                        <figure className="blue">
                            <ReportProblemOutlinedIcon fontSize="large" />
                        </figure>
                    </div>

                    <div className="ai_insight negative">
                        <span>Needs attention</span>
                    </div>
                </a>

            </div>



            <div className="cards mt_20">
                <div className="table_header">
                    <div className="left_s">
                        <Box className="search_box">
                            <SearchBar
                                searchTerm={searchTerm}
                                setDebouncedSearchTerm={setSearchTerm}
                                placeholder="Search..."
                            />
                        </Box>
                    </div>
                    <div className="right_s">
                        <div className="form">
                            <div className="control_group">
                                <input type="date" />
                            </div>

                        </div>
                    </div>

                </div>

                <TableContainer className="table_container">
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Period</TableCell>
                                <TableCell>Type</TableCell>
                                <TableCell>Usage</TableCell>
                                <TableCell>Tokens</TableCell>
                                <TableCell>Credits</TableCell>
                                <TableCell>Cost (USD)</TableCell>
                                <TableCell>Overage</TableCell>
                            </TableRow>
                        </TableHead>


                        <TableBody>
                            {orderData.map((item, index) => (
                                <TableRow key={index} hover>

                                    {/* Period */}
                                    <TableCell>{item.period}</TableCell>

                                    {/* Type */}
                                    <TableCell>
                                        <span className="badge1 info">{item.type}</span>
                                    </TableCell>

                                    {/* Usage */}
                                    <TableCell>{item.usage}</TableCell>

                                    {/* Tokens */}
                                    <TableCell>{item.tokens}</TableCell>

                                    {/* Credits */}
                                    <TableCell>{item.credits}</TableCell>

                                    {/* Cost */}
                                    <TableCell>
                                        <b>{item.cost}</b>
                                    </TableCell>

                                    {/* Overage */}
                                    <TableCell>
                                        <span className="text_danger fw_600">
                                            {item.overage}
                                        </span>
                                    </TableCell>

                                </TableRow>
                            ))}
                        </TableBody>


                    </Table>
                </TableContainer>
            </div>


            <ViewAIHub
                open={openModal}
                onClose={handleCloseModal}
                setOpen={setOpenModal}
            />
        </>
    );
};

export default CostAnalytics;
